<template>
    <div class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto my-4 sm:my-16 px-4 sm:px-8">
            <coming-soon :title="`Immersive Learning Environment`" :show-button="true" button-text="Coming Soon"
                button-icon="clock" />
        </div>
    </div>
</template>
<script>
export default {
    name: "immersive-learning-environment-index",
}
</script>